import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { SessionService } from "../services/session.service";
@Injectable({
  providedIn: "root",
})
export class ProgramadorGuard implements CanActivate {
  constructor(private sessionService: SessionService, private router: Router) {}
  canActivate(): boolean {
    const loginData = this.sessionService.getLoginData();
    if (loginData !== null && loginData.user_name !== null) {
      return true;
    } else {
      this.router.navigate(["/login"]);
      return false;
    }
  }
}
